import EventManagerContainer from "../../container/admin/event-manager";

const EventManager = () => {
    return <EventManagerContainer />;
};

export default EventManager;